// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import {getDefaultState} from '../state';

const resetFullDebitItem = state =>
    Debit.update(state, {
        $set: getDefaultState().debit
    });

const updateFullDebitItem = (state, action) =>
    Debit.update(state, {
        $set: action.debit
    });

const updateFullDebitItemComments = (state, action) =>
    Debit.update(state, {
        reasonForDebit: {
            $set: action.comments
        }
    });

const updateDebitType = (state, action) =>
    Debit.update(state, {
        debitType: {
            $set: action.debitType
        }
    });

export default (state = getDefaultState().debit, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_CLAIM_DEBIT]: resetFullDebitItem,
        [actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM]: updateFullDebitItem,
        [actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM_COMMENTS]: updateFullDebitItemComments,
        [actions.UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_TYPE]: updateDebitType
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/reducers/debit.js